export default {
  $ID: 'simpleLayout1',
  Name: 'Layout 1',
  Model:
  {
    '$ID': 'layout1',
    '$Type': 'dr-simple-layout',
    'Widgets': [
      {
        '$Type': 'dr-simple-layout',
        '$ID': '0.03184060660337029',
        'Widgets': [
          {
            '$Type': 'dr-text',
            '$ID': '0.2474507250165896',
            'Text': 'Template 1',
            'Mode': 'heading1'
          },
          {
            '$Type': 'dr-menu',
            '$ID': '0.211474507250165896'
          },
          {
            '$Type': 'dr-grid-layout',
            '$ID': '0.33265356828367154',
            'Rows': [
              {
                '$ID': '0.2554856739435676',
                'Columns': [
                  {
                    '$ID': '0.9654656515476843',
                    'Weight': '3',
                    'Widgets': [
                      {
                        '$Type': 'dr-layout-placeholder',
                        '$ID': '0.569647525533187',
                        'Name': 'Main'
                      }
                    ],
                    '$Type': 'dr-grid-layout-column'
                  },
                  {
                    '$ID': '0.9537421774137587',
                    'Weight': '9',
                    'Widgets': [
                      {
                        '$Type': 'dr-layout-placeholder',
                        '$ID': '0.10158975128214731',
                        'Name': 'placeholder2'
                      }
                    ],
                    '$Type': 'dr-grid-layout-column'
                  }
                ],
                '$Type': 'dr-grid-layout-row'
              }
            ]
          }
        ]
      },
      {
        '$Type': 'dr-text',
        '$ID': '0.45982766179425116',
        'Text': 'Some footer',
        'Mode': 'heading2'
      }
    ]
  },
  LayoutType: ['responsive']
}
